const REQUEST_MILESTONES = '@@account/REQUEST_MILESTONES';
const MILESTONES_RESPONSE = '@@account/MILESTONES_RESPONSE';

export default {
    REQUEST_MILESTONES,
    MILESTONES_RESPONSE,
};
